
.root {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
}

.notice {
    flex: 0 1 auto;
    /* position outside the bounding box */
    width: 8px;
    margin-left: -8px;
    /* text style */
    writing-mode: vertical-rl;
    text-align: center;
    font-size: 6px;
    white-space: nowrap; /* if the disclaimer is long, keep it all in one line */
}

.content {
    flex: 1 1 auto;
}
